  // eslint-disable-next-line react-hooks/exhaustive-deps
import React, { useState, useEffect, useRef } from "react";
import { useOutletContext, useParams } from "react-router-dom";
import {  Folder } from "lucide-react";
import { Button } from "@mui/material";
import TextInput from "../components/ui/TextInput";
import AddFilesModal from "../components/ui/AddFilesModal";
import UploadFileCard from "../components/ui/UploadFileCard";
import UploadingLoader from "../lib/common/components/loader/UploadingLoader";
import ProjectChatInterface from "../components/project/ProjectChatInterface";
import { useDispatch, useSelector } from "react-redux";
import { trackEvent, trackException } from "../lib/utils/telemetryService";
import { financeAgentChat, getChatBySessionIdForProject, getProjectDetails, projectAgentChat, setProjectChatsessionId, setQueryMessage, setSelectedProjectChat, uploadFiles } from "../lib/redux/actions";
import toast from "../lib/utils/toast";
import { ProjectChatHistory } from "../components/project/ProjectChatHistory";
import { ProjectTogglesRow } from "../components/project/ProjectTogglesRow";


export default function ProjectView() {
  const { name, id,projectType } = useParams();
  const inputRef = useRef(null);
  const [tempId, setTempId] = useState(null);
  const [project, setProject] = useState(null);
  const [isAddFilesOpen, setIsAddFilesOpen] = useState(false);
  const [attachedFiles, setAttachedFiles] = useState([]);
  const [inputText, setInputText] = useState("");
  const [loading, setLoading] = useState(false);
  const { projectChats, setProjectChats, fetchRecentChats, chatModels, setModelSelectorConfig, isMobile, sidebarOpen } = useOutletContext();
  const scrollRef = useRef(null);
  const { selectedProjectChat } = useSelector(
    (state) => state.chat
  );
  const isSelectedSessionId = useRef(selectedProjectChat);



  useEffect(() => {
    isSelectedSessionId.current = selectedProjectChat;
  }, [selectedProjectChat]);

  // Props for TextInput to prevent errors
  const [files, setFiles] = useState([]);
  const [inputFocused, setInputFocused] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const fileInputRef = useRef(null);

  const dispatch = useDispatch();
  useEffect(() => {
    // Mock fetch project details
    fetchProjectDetails()
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name, id]);

  const handleAttachFiles = (newFiles) => {
    // newFiles now contains { file, fileUrl, fileName } from the modal
    setAttachedFiles(prev => [...prev, ...newFiles]);
  };

  const handleChatResponse = async ({ text, value, media = [] } = {}) => {
    let tempSessionId = selectedProjectChat?._id || isSelectedSessionId?.current?._id;
    setTempId(selectedProjectChat?._id || isSelectedSessionId?.current?._id);

    const tempUserMessage = {
      role: "user",
      message: text || inputText,
      model_name: "openai",
      // sessionId: tempSessionId || `temp-user-${Date.now()}`,
      ...(media.length > 0 && { media: media.map((file) => file.fileUrl) }),
      doc: media.length > 0 ? `temp-user-${Date.now()}` : null,
    }; 
    dispatch(setQueryMessage(tempUserMessage));
    dispatch(setProjectChatsessionId(selectedProjectChat?._id));

    setTimeout(() => {
      if (scrollRef.current) {
        scrollRef.current.scrollTop = 0;
      }
    }, 100); // small delay ensures DOM update
    try {
      setLoading(true);

      const textInput = text || inputText;

      if (!textInput.trim()) {
        return;
      }

      // Clear input
      setInputText("");

      // Add user message optimistically
      const userMessage = {
        role: "user",
        message: textInput,
        _id: `temp-user-${Date.now()}`,
        ...(media.length > 0 && { media: media.map((file) => file.fileUrl) }),
        doc: media.length > 0 ? `temp-user-${Date.now()}` : null,
        sessionId: tempSessionId || `temp-user-${Date.now()}`,
      };
      setProjectChats((prev) => [...prev, userMessage]);
      
      const payload = {
        question: textInput,
        projectId:id,
        ...(media.length > 0 && { media }),
      };

      const payload2 = {
        message: textInput,
        projectId:id,
        ...(media.length > 0 && { media }),
      };
      let res;
      if(projectType === "finance"){
       res = await financeAgentChat(payload2);
        await handleBotResponse(res);
      }else if(projectType === "generic"){
       res = await projectAgentChat(payload);
       await handleBotResponse(res);
      }
     
     
    } catch (error) {
      handleError(error);
      trackException(error);
      trackEvent("SendMessage_Failed");
    } finally {

      setLoading(false);
    }
  };

  const handleBotResponse = async (res) => {
    const { data } = res;
    if (!data) return;
    const botMessage = {
      role: "assistant",
      message: data?.answer || data?.response,
      _id: data?.assistantChat?._id,
      doc: data?.userChat?.media[0]?._id || null,
      latest_message: true,
      insights:data?.insights,
      charts:data?.charts,
      sessionId: data?.sessionId,
    };
    const resData = await getChatBySessionIdForProject(data?.sessionId);

    if (!selectedProjectChat?._id) {
      selectedProjectChat?._id && setProjectChats([]);
      dispatch(setProjectChatsessionId(""));

      fetchRecentChats();
      fetchProjectDetails()
      const newSessionId = resData?.data?._id;
      if (newSessionId) {
        // const newPath = `/chat/${newSessionId}`;
        const newPath  =`/project/${name}/${projectType}/${id}/${newSessionId}`
        window.history.pushState({}, "", newPath);
      }

      dispatch(setSelectedProjectChat(resData?.data));
    }
   
    setProjectChats((prev) => [...prev, botMessage]);
  

  };

  const handleError = (error) => {
    const errorBotMessage = {
      role: "assistant",
      message: error?.message || "Something went wrong!!",
      _id: `error-bot-${Date.now()}`,
      statusCode: "error",
    };
    trackException(error); trackEvent("SendMessage_Error", { message: error?.message });
    setProjectChats((prev) => [...prev, errorBotMessage]);
  };




  const handleFileChange = async (e) => {
    const selectedFiles = e.target.files;
    if (!selectedFiles || selectedFiles.length === 0) return;

    const allowedTypes = [
      "text/csv",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
      "application/pdf",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
      "image/jpeg",
      "image/png",
    ];
    if (files.length + selectedFiles.length > 3) {
      toast.error("You can only upload up to 3 files in total.");
      if (fileInputRef.current) fileInputRef.current.value = "";
      return null;
    }

    const MAX_FILE_SIZE_MB = 10;
    const validFiles = Array.from(selectedFiles).filter((file) => {
      const isValidType = allowedTypes.includes(file.type);
      const isValidSize = file.size <= MAX_FILE_SIZE_MB * 1024 * 1024;

      if (!isValidType) {
        toast.error(`Unsupported format: ${file.name}`);
        return false;
      }

      if (!isValidSize) {
        toast.error(`File size is too big (Maximum allowed size is 10MB)`);
        return false;
      }

      return true;
    });

    if (validFiles.length === 0) return;

    try {
      setIsUploading(true);
      const formData = new FormData();
      validFiles.forEach((file) => {
        formData.append("files", file);
      });
      trackEvent("FileUpload_Start", { fileCount: validFiles.length });
      const result = await uploadFiles(formData);

      if (result.statusCode === 200) {
        trackEvent("FileUpload_Success", { uploaded: result.data.length })
        const newFileObjs = result.data.map((url, index) => ({
          fileUrl: url,
          fileName: validFiles[index].name,
        }));
        setFiles((prev) => {
          const combined = [...prev, ...newFileObjs].slice(0, 3);
          return combined;
        });
        // Reset file input so re-selecting the same file triggers onChange
        if (fileInputRef.current) fileInputRef.current.value = "";
      }
    } catch (error) {
      trackException(error);
      trackEvent("FileUpload_Failed");
      console.error("File upload failed:", error);
      toast.error("File upload failed. Please try again.");
    } finally {
      setIsUploading(false);
    }
  };

  const removeFile = (index) => {
    setFiles((prev) => {
      const next = prev.filter((_, i) => i !== index);
      // Also clear the input to allow selecting the same file again
      if (fileInputRef.current) fileInputRef.current.value = "";
      return next;
    });
  };

  const fetchProjectDetails = async () => {
    try {
      const result = await getProjectDetails({ projectId: id });
      if (result.statusCode === 200) {
        setProject(result?.data?.project);
      }
    } catch (error) {
      trackException(error);
      console.error("Failed to fetch project details:", error);
    }
  };

  // if (!project) return <div>Loading...</div>;


  if (projectChats.length > 0) {
    return <ProjectChatInterface
      isMobile={isMobile}
      sidebarOpen={sidebarOpen}
      setChats={setProjectChats}
      chats={projectChats}
      fetchRecentChats={fetchRecentChats}
      chatModels={chatModels}
      setModelSelectorConfig={setModelSelectorConfig}
      projectName={decodeURIComponent(name)}
      parentProjectId ={id}
      sessionId={null}
      viewLoading={loading}
      viewTempId={tempId}
    />
  }

  const Icon = Folder;
  return (
    <div className={`flex-1 flex flex-col overflow-scroll sm:overflow-hidden  ${isMobile && sidebarOpen ? "opacity-50" : ""
      }`}
    >
      <div className="min-h-full sm:h-full sm:min-h-[calc(100vh-3rem)] flex flex-col items-center justify-start sm:justify-center w-full px-4 sm:px-6 md:px-10 lg:px-12 pt-20 sm:pt-10 pb-10">
        {/* Header / Project Info Area */}
        <div className="flex flex-row w-full items-center justify-between md:max-w-[768px] 2xl:max-w-5xl">
          <div className="flex items-center gap-4 ">
            <Icon className="w-10 h-10 text-[#1B5C29]" />
            <h1 className="text-4xl font-normal text-gray-800">{name}</h1>
          </div>

          <div className="flex items-center gap-2 ">
            {project?.files?.length > 0 && (
              <div className="flex gap-2">
                <span className="bg-gray-100 text-gray-600 px-3 py-1 rounded-full text-sm border border-gray-200">
                  {project?.files?.length} files
                </span>
              </div>
            )}
            <Button
              variant="contained"
              onClick={() => setIsAddFilesOpen(true)}
              style={{ backgroundColor: "#1B5C29", textTransform: 'none', borderRadius: 8 }}
            >
              Add files
            </Button>
          </div>
        </div>

        {/* File preview cards - outside the input box */}
        <div className="w-full md:max-w-[768px] 2xl:max-w-5xl mt-1">
          <div className="flex flex-row gap-4 items-center">
            {files.length > 0 && (
              <div className="flex flex-wrap gap-2 mb-2">
                {files.map((file, index) => (
                  <UploadFileCard
                    key={`uploadfilecard-${file?.fileUrl}`}
                    file={file}
                    index={index}
                    removeFile={removeFile}
                  />
                ))}
              </div>
            )}
            {isUploading && <div className="flex flex-row gap-4 items-center ">
              <UploadingLoader />
              <span className="text-sm text-gray-500">Uploading File...</span>
            </div>
            }
          </div>
        </div>
        {/* Main card */}
        <div
          className={`w-full md:max-w-[768px] 2xl:max-w-5xl ${files.length > 0 ? "mt-2" : "mt-2"
            } overflow-hidden`}
        >
          {/* Input area */}
          <div className="">
            <TextInput
              inputRef={inputRef}
              inputText={inputText}
              placeholder="New Chat"
              handleChatResponse={handleChatResponse}
              setInputText={setInputText}
              inputFocused={inputFocused}
              setInputFocused={setInputFocused}
              loading={loading}
              disabled={false}
              fileInputRef={fileInputRef}
              handleFileChange={handleFileChange}
              isUploading={isUploading}
              files={files}
              // isMultipleFileUploadEnabled={true}
              setFiles={setFiles}
              chats={projectChats}
              // isFileUploadOptionVisible={true}
              isContentRendering={loading}
              requireMediaToSend={false}
              isFileUploadOptionVisible={false}
              showPromptActions={false}
              // showInlineUtilities={false}
              useNativePlaceholder={true}
              // inputVariant="flat"
              allowedFileTypes=".pdf,.doc,.docx"
            />
          </div>


          {/* Toggles row */}
          <ProjectTogglesRow projectType={projectType} />


        </div>

        {/* project chat history */}
        <ProjectChatHistory projectType={projectType} sessions={project?.sessions} projectId={project?._id} projectName={project?.projectName} setProjectChats={setProjectChats}/>
      </div>



      <AddFilesModal
        open={isAddFilesOpen}
        onClose={() => setIsAddFilesOpen(false)}
        onAttachFiles={handleAttachFiles}
        attachedFiles={attachedFiles}
        projectType={projectType}
        projectId={id}
        projectFiles={project?.files}
        fetchProjectDetails={fetchProjectDetails}
      />
    </div>
  );
}
